import React from 'react';
import { Video } from 'lucide-react';

interface MediaEntry {
  id: string;
  url: string;
  type: 'image' | 'video';
  credit: string;
  credit_url: string;
}

interface MediaEntryListProps {
  entries: MediaEntry[];
  onChange?: (entries: MediaEntry[]) => void;
  readOnly?: boolean;
}

const MediaEntryList = ({ entries, onChange, readOnly = false }: MediaEntryListProps) => {
  const renderPreview = (entry: MediaEntry) => {
    if (!entry.url) return null;

    if (entry.type === 'image') {
      return (
        <div className="w-20 h-20 rounded-lg overflow-hidden bg-background-secondary">
          <img
            src={entry.url}
            alt="Preview"
            className="w-full h-full object-cover"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
        </div>
      );
    }

    return (
      <div className="w-20 h-20 rounded-lg bg-background-secondary flex items-center justify-center">
        <Video className="w-8 h-8 text-content-secondary" />
      </div>
    );
  };

  return (
    <div className="space-y-4">
      {entries?.map((entry) => (
        <div
          key={entry.id || entry.url} // Use URL as fallback if no ID
          className="bg-background-secondary rounded-lg p-4 border border-gray-800"
        >
          <div className="flex items-start gap-4">
            {/* Preview */}
            {renderPreview(entry)}

            {/* Fields */}
            <div className="flex-1 space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Media URL
                  </label>
                  <input
                    type="url"
                    value={entry.url}
                    readOnly
                    className="w-full px-3 py-2 bg-background border border-gray-800 rounded-lg opacity-75"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Type
                  </label>
                  <input
                    type="text"
                    value={entry.type}
                    readOnly
                    className="w-full px-3 py-2 bg-background border border-gray-800 rounded-lg opacity-75"
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Credit
                  </label>
                  <input
                    type="text"
                    value={entry.credit}
                    readOnly
                    className="w-full px-3 py-2 bg-background border border-gray-800 rounded-lg opacity-75"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Credit URL
                  </label>
                  <input
                    type="url"
                    value={entry.credit_url}
                    readOnly
                    className="w-full px-3 py-2 bg-background border border-gray-800 rounded-lg opacity-75"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MediaEntryList;